module.exports = "<div class=\"image_layout\">\r\n  <div class=\"image\" (click)=\"onClickHotsPost($event)\" #layoutImage [attr.id]=\"widget._id\">\r\n    <img class=\"target\" [src]=\"widget.image\"  style=\"width: 100%;\"/>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/components/graphs/static-layout-map/static-layout-map.component.html
// module id = ../../../../../src/app/shared/components/graphs/static-layout-map/static-layout-map.component.html
// module chunks = main